__turbopack_context__.v({
  "className": "satisfy_53d2a027-module__Wd6kja__className",
  "variable": "satisfy_53d2a027-module__Wd6kja__variable",
});
